import { alpha, Button, Stack } from '@mui/material'
import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useScreenSize } from '../../sharedComponents/src/hooks/useScreenSize'

export const NavTabs: FC<{
    tabs: Record<string, string>
    badges?: Record<string, boolean | undefined>
}> = ({ tabs, badges }) => {
    const { isMobile } = useScreenSize()

    const { currentTab, changeTab, tabsList } = useNavTabs(tabs)

    useEffect(() => {
        if (!currentTab || !tabsList.includes(currentTab)) {
            changeTab(tabsList[0])
        }
    }, [currentTab])

    return (
        <Stack
            direction="row"
            spacing={1}
            // mb={1}
            zIndex={0}
            sx={{
                position: 'sticky',
                top: { xs: '60px', md: '88px' },
                zIndex: 1002,
                boxShadow: (theme) => `0px -2px 16px 15px ${alpha(theme.palette.background.default, 0.7)}`,
                // filter: 'drop-shadow(2px 4px 8px rgba(0, 0, 0, 0.3))',
                backgroundColor: 'background.default',
            }}
        >
            {tabsList.map((item) => (
                <Button
                    badge={badges?.[item]}
                    key={item}
                    tab
                    size={isMobile ? 'medium' : 'large'}
                    onClick={() => {
                        changeTab(item)
                        window.scrollTo({ top: 0 })
                    }}
                    fullWidth
                    selected={item === currentTab}
                >
                    {item}
                </Button>
            ))}
        </Stack>
    )
}

export const useNavTabs = (tabs?: Record<string, string>) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const tabsList = Object.values(tabs || {})
    const currentTab = searchParams.get('tab') || ''

    const changeTab = (value) => {
        searchParams.set('tab', value)
        setSearchParams(searchParams, { replace: true })
    }

    return {
        currentTab,
        changeTab,
        tabsList,
    }
}
